import React from "react";

export const taxCreditData = {
  eligibleNumber: 200,
  potentialAmount: 1025212.24,
  practicesInProgress: 30,
  practicesTotal: 60,
  taxCreditDisbursed: 400432.12,
  yearRef: 2021,
  practices: [
    {
      counterpart: "Baol Edizioni",
      type: "Editoria/Formazione industria 4.0",
      total: 7,
      completed: 4,
      amount: 12300
    },
    {
      counterpart: "IWOOD MARINE SRL",
      type: "Dpi e Sanificazione/Editoria",
      total: 7,
      completed: 5,
      amount: 8500
    },
    {
      counterpart: "B2B Ristorante",
      type: "Editoria/Formazione industria 4.0",
      total: 6,
      completed: 2,
      amount: 1540
    },
    {
      counterpart: "Italy Service",
      type: "Editoria / Spese ICT",
      total: 7,
      completed: 2,
      amount: 27700
    },
    {
      counterpart: "Multimedia spa",
      type: "Editoria / Spese ICT",
      total: 7,
      completed: 1,
      amount: 6300
    },
    {
      counterpart: "2B costruzioni",
      type: "Editoria / Spese ICT",
      total: 7,
      completed: 1,
      amount: 980
    }
  ],
  activeTaxCredit: [
    {
      title: "DPI e sanificazione",
      description: "Imprese residenti ITA",
      totalCompanies: 30
    },
    {
      title: "Formazione 4.0",
      description: "Tutte le P.IVA (ad esclusione occasionali e P.F)",
      totalCompanies: 28
    },
    {
      title: "Investimenti nel mezzogiorno",
      description: "Imprese residenti ITA",
      totalCompanies: 15
    },
    {
      title: "Editori",
      description: (
        <>
          ATECO Editoria
          <br />
          Iscrizione all'albo
        </>
      ),
      totalCompanies: 12
    },
    {
      title: "Bonus riqualificazione strutture turistico ricettive",
      description: "Imprese residenti ITA",
      totalCompanies: 630
    },
    {
      title: "Digitalizzazione esercizi ricettivi",
      description: "Imprese residenti ITA",
      totalCompanies: 522
    },
    {
      title: "Ricerca e sviluppo",
      description: "Tutte le P.IVA (ad esclusione occasionali e P.F)",
      totalCompanies: 30
    },
    {
      title: "Restauro sale cinematografiche",
      description: "Tutte le P.IVA (ad esclusione occasionali e P.F)",
      totalCompanies: 11
    },
    {
      title: "Investimenti pubblicitari",
      description: "Tutte le P.IVA (ad esclusione occasionali e P.F)",
      totalCompanies: 120
    },
    {
      title: "Sisma bonus",
      description: "Imprese residenti ITA",
      totalCompanies: 12
    }
  ],
  eligibleCompanies: [
    {
      description: "Alfa srl",
      number: 3,
      amount: 15752
    },
    {
      description: "Erin srl",
      number: 3,
      amount: 15752
    },
    {
      description: "Artu spa",
      number: 10,
      amount: 120752
    },
    {
      description: "Fabbric spa",
      number: 10,
      amount: 120752
    },
    {
      description: "Bizz srl",
      number: 3,
      amount: 15752
    },
    {
      description: "Fubiz srl",
      number: 3,
      amount: 15752
    },
    {
      description: "Cri spa",
      number: 22,
      amount: 12752
    },
    {
      description: "Garden spa",
      number: 22,
      amount: 12752
    },
    {
      description: "Droni spa",
      number: 2,
      amount: 752
    },
    {
      description: "Hotel spa",
      number: 2,
      amount: 752
    }
  ]
};

export const taxCreditDetail = {
  counterpart: {
    description: "IWOOD MARINE SRL",
    address: "Via Visconti di Modrone, 4 - Milano 20100 - ML, Italy",
    taxId: "02465440416",
    vatNumber: "02465440416",
    atecoCode: "10245"
  },
  taxCreditObtainedAmount: 12000,
  taxCreditObtainedNumber: 3,
  taxCreditRequestedAmount: 16000,
  taxCreditRequestedNumber: 5,
  eligibleCredits: [
    {
      id: 1,
      title: "Bonus riqualificazione strutture turistico ricettive",
      description: "",
      tags: ["Imprese italiane"]
    },
    {
      id: 2,
      title: "DPI e Sanificazione",
      description: "",
      tags: ["Imprese italiane"]
    },
    {
      id: 3,
      title: "Formazione 4.0",
      description: "",
      tags: ["Editoria"]
    },
    {
      id: 4,
      title: "Sisma bonus",
      description: "",
      tags: ["Imprese italiane"]
    },
    {
      id: 5,
      title: "Ricerca e sviluppo",
      description: "",
      tags: ["SPA"]
    },
    {
      id: 6,
      title: "Investimenti pubblicitari",
      description: "",
      tags: ["SPA"]
    }
  ],
  inProgressCredits: [
    {
      id: 1,
      title: "Spese di marketing",
      description: "",
      tags: ["Editoria"],
      completed: 4,
      total: 8,
      amount: 2000
    },
    {
      id: 2,
      title: "Corsi sicurezza",
      description: "",
      tags: ["SPA"],
      completed: 4,
      total: 8,
      amount: 8000
    },
    {
      id: 4,
      title: "Formazione",
      description: "",
      tags: ["Imprese italiane"],
      completed: 4,
      total: 8,
      amount: 6300
    }
  ],
  archivedCredits: []
};

export const taxCreditElegibleDetail = {
  title: "Bonus riqualificazione strutture turistico ricettive",
  description: "Credito d’imposta per la riqualificazione delle strutture ricettive teso al rilancio del settore turistico.",
  items: [
    {
      id: 1,
      title: "Requisiti soggettivi",
      items: []
    },
    {
      id: 2,
      title: "Requisiti oggettivi",
      items: []
    },
    {
      id: 3,
      title: "Importo del beneficio",
      items: []
    },
    {
      id: 4,
      title: "Modalità di richiesta",
      items: []
    },
    {
      id: 5,
      title: "Modalità di utilizzo",
      items: []
    }
  ]
};

export const taxCreditInProgressDetail = {
  title: "Spese di marketing",
  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ut nisi imperdiet, ullamcorper arcu eget, dignissim arcu.",
  items: []
};
